export default __webpack_public_path__ + "static/media/Panos_pizza.8f9b7e91.png";